/*jslint devel: true, browser: true, confusion: true, vars: true, white: true, plusplus: true, maxerr: 50, indent: 4 */

"use strict";

import {Filter} from './filter.js';
import {FilterManager} from './filter-manager.js';

KSU.domReady(function() {

	var $ = document.querySelector.bind(document);
        var
        hbtemplate,
        hbtemplatenomatch,
        hbBadgeTemplate,
        prevquery = "neverloaded"
            ;

        var buildDataArray = function(data) {

            var fields = data.values[0];
            var values = data.values.slice(1);
            console.log(values);
            var newdata = [];

            values.forEach(function(val) {

                    var newobj = {};
                    fields.forEach(function(field, i) {
                        var v = val[i];
                        newobj[field] = v;
                    });

                newdata.push(newobj);

            });

            return newdata;
        };

        var parseContactEmail = function(data) {

            data.forEach(function(obj) {

                if (obj.contact) {
                    obj.htmlcontact = obj.contact.replace(/<(.+?)>/g,
                        '<a href="mailto:$1">$1</a>');
                }

            });

            return data;
    };
    
    var logQuery = function() {
        var keyword = this.getFilterValue('keyword')||'(blank)',
            label = this.name,
			inputelement;
		
        if (!this.results.length) {
           keyword += ' -- no match';
        }
		keyword = keyword.toLowerCase();
        ga('site.send', 'event', 'Program search', keyword, label, {noninteraction:1});
        console.log("Logging", keyword, label);
        };


    var getTemplateText = function(selector) {
          var text;

          console.log("Selector:", selector);
          text = $(selector).innerHTML;
          text = text.replace(/^[\s\/]+/g, "");
          text = text.replace(/[\s\/]+$/g, "");

          console.log(text);
          return text;
       };

       var getLocations = function(item) {
        var result = [];

        if (item.man) {
                result.push({'key': 'manhattan', 'name': 'Manhattan', 'url': "https://www.k-state.edu/"});
        }
        if (item.poly) {
                result.push({'key': 'polytechnic', 'name': 'Polytechnic', 'url': "https://polytechnic.k-state.edu/"});
        }
        if (item.olathe) {
                result.push({'key': 'olathe', 'name': 'Olathe', 'url': "https://olathe.k-state.edu/"});
        }
        if (item.online) {
                result.push({'key': 'online', 'name': 'Online', 'url': "https://online.k-state.edu/"});
        }

        return result;
};

	/* From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/entries */
	if (!Object.entries) {
        Object.entries = function( obj ){
            var ownProps = Object.keys( obj ),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
            while (i--)
                resArray[i] = [ownProps[i], obj[ownProps[i]]];
        
            return resArray;
        };
    }


        var hilight = function(query, text) {

            var html;

            text = text || "";

            html = text;
            
			query = query.trim();
            if (query) {
                html = text.replace(new RegExp(_.escapeRegExp(query), "gi"), "<span class='highlight'>$&</span>");
            }

            return html;
        };

        var buildResponsibilitiesString = function(row) {
            var r = [];

            if (row.mentors) { r.push("mentors"); }
            if (row.coaches) { r.push("coaches"); }
            if (row.classroom) { r.push("facilitates classroom learning"); }
            if (row.smallgroups) { r.push("facilitates small group or one-on-one learning"); }
            if (row.outreach) { r.push("facilitates/presents outreach programs"); }
            if (row.challenges) { r.push("mediates challenges"); }
            if (row.coordinates) { r.push("coordinates programming and adminstrative responsibilities"); }

            return r.join('; ');
        }

        // Iterate over the array of career match objects and returns
        // an HTML string.
        var formatOpportunities = function(results) {

			var query = [];
			var value;
			
			// if (query.length) {
			// 	query = query.join(', ');
			// } else {
			// 	query = '';
			// }
			// query = "This needs to handle multiple values";

            if (!results.length) {
                return hbtemplatenomatch({query: query});
            }

            results.forEach(function(row) {
                if (row.contact) {
                    row.htmlcontact = row.contact.replace(/<(.+?)>/g,
                        '<a href="mailto:$1">$1</a>');
                }

                row.responsibilities = buildResponsibilitiesString(row);

				fm.filters.forEach(function(filter){
					if (filter.inputtype==='text') {
						filter.fields.forEach(function(field) {
                            // TODO: skip highlighting for now
							// row["html"+field] = hilight(query, filter, _.escape(row[field]));
                            if (!row["html"+field]) {
							    row["html"+field] = _.escape(row[field]);
                            }
						});
					}
				});
			});

            console.log("Augmented", results);
			return hbtemplate(results);

        };


        var formatBadges = function(badgedata) {

			return hbBadgeTemplate(badgedata);

        };

        var compareName = function(a, b) {

           var avalue = a.name,
           bvalue = b.name;

           if (avalue < bvalue) {
              return -1;
           }

           if (avalue > bvalue) {
              return 1;
           }


           /*
            * Give up, and say the operands are equal.
            */
           return 0;
        };


        var compareIaWeightName = function(a, b) {

           var avalue = a.iaweight,
           bvalue = b.iaweight;

           if (avalue > bvalue) {
              return -1;
           }

           if (avalue < bvalue) {
              return 1;
           }


           /*
            * Give up, compare with the next field.
            */
           return compareName(a, b);
        };

    hbtemplate = Handlebars.compile(getTemplateText('#result-template'));
    hbtemplatenomatch = Handlebars.compile(getTemplateText('#result-template-no-match'));

    var preprocessData = function(data) {
        var data = buildDataArray(data);
        // data = parseContactEmail(data);

        console.log("Processed data", data);
        return data;
    }


   var fm = new FilterManager(
        'https://www.k-state.edu/student-success/initiatives/peer-mentoring/filter-tool/mentor-data-from-google-sheet.json', {
        form: '#opportunity-filter form',
        preprocessData: preprocessData,
       	// sort: compareIaWeightName,
        msglevel: 9,
        // fnPostFilter: postFilter,
//      fnLog: logQuery,
       	name: "opportunities"
        }
   );

    fm.addFilter(new Filter({
        name: "keyword",
        selector: "input[type='text']",
        inputtype: 'text',
        matchtype: 'text',
        fields: ["title", "description", "contact"],
        msglevel: 9,
        processNullQuery: true
    }));

    fm.addFilter(new Filter({
        name: "location",
        selector: "select[name='location']",
        inputtype: 'select',
        matchtype: 'true-property',
        // fields: ["location"],
        // type: "select",
        msglevel: 9,
        processNullQuery: true
    }));

    fm.addFilter(new Filter({
        name: "responsibilities",
        selector: "select[name='responsibilities']",
        inputtype: 'select',
        matchtype: 'true-property',
        // fields: ["responsibilities"],
        // type: "select",
        msglevel: 9,
        processNullQuery: true
    }));

    fm.addFilter(new Filter({
        name: "category",
        selector: "select[name='categories']",
        inputtype: 'select',
        matchtype: 'true-property',
        // fields: ["responsibilities"],
        // type: "select",
        msglevel: 9,
        processNullQuery: true
    }));

    //    fm.addFilter(new Filter({
//        name: "attribute",
// 	   inputtype: 'radio-checkbox', 
//        selector: ".location-block input",
// 	   matchtype: "true-property",
//        msglevel: 9,
//        processNullQuery: true
//    }));

   fm.setOutput({
       selector: "#js-insert-opportunities",
       fnFormat: formatOpportunities
//        postprocess: postProcess
   });

	fm.loadState(KSU.programFilterDefaults);
   	fm.render();

});
